/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Container, Form, InputGroup, Button } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import * as formik from "formik";
import * as yup from "yup";
import "./styles.scss";
import EmailTempalte from "./template/emailPreview";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  getEmailRecipients,
  getTestUsers,
  sendAdminEmail,
  checkUserSettingsEnabled,
} from "../../../redux/admin";
import Header from "../../../components/Header";
import CustomModal from "../CustomModal";
import Select from "react-select";

const customStyles = {
  menu: (provided) => ({
    ...provided,
    maxHeight: 200, // Set max height for the dropdown
    overflowY: "hidden", // Add scrolling if the content exceeds the maxHeight
  }),
};

const initialValues = {
  checkboxes: [false, false, false],
  subject: "",
  text_message: "",
  submitAction: "",
};

const schema = yup.object().shape({
  submitAction: yup.string().required(),
  subject: yup.string().required(),
  text_message: yup.string().required(),
  checkboxes: yup
    .array()
    .of(yup.boolean())
    .test(
      "at-least-one-checked",
      "Please select at least one option",
      (value) => value?.some(Boolean)
    ),
});

const AdminEmail = () => {
  // const [fieldValue, setFieldValue] = useState([false, false, false]);
  const [showErrorModal, setshowErrorModal] = useState(false);
  const [recipientOptions, setRecipientOptions] = useState([]);
  const [custom_greeting, setCustom_greeting] = useState("Hi");
  const [showCustomGreetingInp, setShowCustomGreetingInp] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [mailData, setMailData] = useState({});
  const [displayUsersInModal, setDisplayUsersInModal] = useState([]);
  const [resetFormFunc, setResetFormFunc] = useState(null);
  const items = [
    "Important updates",
    "Product updates",
    "General communications",
  ];
  const [selected, setSelected] = useState([]);

  const { emailRecipients, emailTestUsers } = useSelector(
    (state) => state.admin
  );

  const handleChangeCheckbox = (e, index, setFieldValue, values) => {
    const updatedValues = [...values.checkboxes];
    updatedValues[index] = e.target.checked;
    setFieldValue("checkboxes", updatedValues); // Update Formik's values directly
  };

  const dispatch = useDispatch();
  const { adminEmailData } = useSelector((state) => state?.admin);

  const onSubmit = (data, { resetForm }) => {
    if (
      !data?.checkboxes?.length ||
      data?.checkboxes?.every((val) => val === false)
    ) {
      setshowErrorModal(true);
      setShowConfirmModal(false);
      return;
    }
    if (data.submitAction === "test_email" && !selected.length) {
      alert("No test user selected!");
      return;
    }

    let selectedUsers = [];

    selectedUsers = selected.map((option) => option.value);

    setShowConfirmModal(true);
    dispatch(checkUserSettingsEnabled({ data, selectedUsers }))
      .unwrap()
      .then((res) => {
        console.log(res);
        setDisplayUsersInModal(res.response.data.usernames);
        setMailData(data);
        setResetFormFunc(() => resetForm);
      });
  };

  const getRecipientsList = () => {
    try {
      const updates = {
        important_updates: true,
      };
      dispatch(getEmailRecipients({ updates: updates }));
    } catch (error) {}
  };

  useEffect(() => {
    const mutiselectOptions = emailRecipients?.data?.map((user) => {
      return {
        label: `${user.username}`,
        value: user._id,
      };
    });
    setRecipientOptions(mutiselectOptions);
  }, [emailRecipients]);

  useEffect(() => {
    if (emailTestUsers?.data?.length > 0) {
      const testUserOptions = emailTestUsers?.data?.map((user) => {
        return {
          label: `${user.username}`,
          value: user._id,
        };
      });
      setSelected(testUserOptions);
    }
  }, [emailTestUsers]);

  useEffect(() => {
    if (!showCustomGreetingInp) {
      setCustom_greeting("Hi");
    }
  }, [showCustomGreetingInp]);

  const confirmOnSubmit = () => {
    const fieldValue = mailData.checkboxes;
    const updates = {
      important_updates: fieldValue[0],
      product_updates: fieldValue[1],
      general_communications: fieldValue[2],
    };
    let selectedUsers = [];
    if (selected?.length) {
      selectedUsers = selected.map((option) => option.value);
    }
    if (mailData.submitAction === "send_email") {
      dispatch(
        sendAdminEmail({
          ...mailData,
          updates: updates,
          selectedUsers: [],
          custom_greeting,
        })
      )
        .unwrap()
        .then((res) => {
          if (res?.response?.status === 200) {
            toast.success(res?.response?.data?.message);
          } else if (res?.response?.status === 201) {
            toast.error(res?.response?.data?.message);
          } else {
            toast.success("Some thing went wrong!");
          }
        });
    } else if (mailData.submitAction === "test_email") {
      if (selectedUsers.length === 0) {
        alert("No test user selected!");
        return;
      }
      dispatch(
        sendAdminEmail({
          ...mailData,
          updates: updates,
          selectedUsers,
          custom_greeting,
        })
      )
        .unwrap()
        .then((res) => {
          if (res?.response?.status === 200) {
            toast.success(res?.response?.data?.message);
          } else if (res?.response?.status === 201) {
            toast.error(res?.response?.data?.message);
          } else {
            toast.success("Some thing went wrong!");
          }
        });
    }

    // styles = { customStyles };
    setShowConfirmModal(false);
    if (resetFormFunc) resetFormFunc();
  };

  const handleCloseConfirmModal = () => {
    setShowConfirmModal(false);
  };

  const modalTitle = "Send Email";

  const modalContent = (
    <div>
      Do you want to proceed with sending the emails to the selected users?
      <div>
        These users will receive the mail:
        {displayUsersInModal?.length > 0 ? (
          displayUsersInModal.map((userInModal) => (
            <div key={userInModal}>{userInModal}</div>
          ))
        ) : (
          <div>No users</div>
        )}
      </div>
    </div>
  );

  const modalFooterButtons = [
    { label: "Close", variant: "danger", onClick: handleCloseConfirmModal },
    {
      label: "Send",
      variant: "primary",
      onClick: confirmOnSubmit,
      disabled: displayUsersInModal?.length === 0,
    },
  ];

  useEffect(() => {
    getRecipientsList();
    dispatch(getTestUsers());
  }, []);
  return (
    <div className="admin_email_page">
      <Header />
      <Container className="mx-auto p-2 email-form">
        <formik.Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={initialValues}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            touched,
            errors,
            setFieldValue,
          }) => (
            <Row className="justify-content-start mx-auto admin-mail-box">
              <Col xs={12} md={6}>
                <section className="security_section mt-0">
                  <div className="security_wrapper devide-sec mb-1 ">
                    {/* <h2>Email subscription</h2> */}

                    <h4 className="receive-email mb-5">Send email about:</h4>
                    <Form>
                      <div className="d-flex flex-row">
                        {items.map((item, index) => (
                          <Form.Check key={index} className="me-4 mb-0">
                            <div className="d-inline-flex align-items-start">
                              <Form.Check.Input
                                type="checkbox"
                                id={`${index}`}
                                name={`checkboxes[${index}]`}
                                onChange={(e) =>
                                  handleChangeCheckbox(
                                    e,
                                    index,
                                    setFieldValue,
                                    values
                                  )
                                } // Handle change
                                checked={values?.checkboxes?.[index]}
                                value={index}
                                className={`${
                                  values?.checkboxes?.[index] ? "bg_btn" : ""
                                } ${errors.checkboxes && "border-danger"}`}
                              />
                              <Form.Check.Label className="notify-items mb-0 ms-1">
                                {item}
                              </Form.Check.Label>
                            </div>
                          </Form.Check>
                        ))}
                      </div>
                      {errors?.checkboxes && touched?.checkboxes && (
                        <div className="text-danger mt-2 p-0 small">
                          {errors.checkboxes}
                        </div>
                      )}
                    </Form>
                  </div>
                </section>
                <section>
                  {/* commenting temporarily till the backend code is deployed */}
                  {/* <div className="mb-2">
                    <label>Select users to send email</label>
                    <MultiSelect
                      options={recipientOptions}
                      value={selected}
                      onChange={setSelected}
                      labelledBy="Select"
                      valueRenderer={customOptionRenderer} // Render custom option with cross button

                    />
                  </div> */}
                  <div className="my-4 d-flex align-items-end justify-content-between">
                    <div className="mb-2 d-flex align-items-center  h-100">
                      <input
                        id="custom-greeting"
                        type="checkbox"
                        className="me-2"
                        defaultChecked={showCustomGreetingInp}
                        onClick={(e) =>
                          setShowCustomGreetingInp(e.target.checked)
                        }
                      ></input>
                      <label htmlFor="custom-greeting">Custom Greeting</label>
                    </div>
                    <div className="ms-2">
                      <input
                        className="form-control p-2"
                        disabled={!showCustomGreetingInp}
                        onChange={(e) => setCustom_greeting(e.target.value)}
                        value={custom_greeting}
                      ></input>
                    </div>
                  </div>
                  <Form noValidate onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="validationFormik101"
                        className="position-relative"
                      >
                        <Form.Label>Subject</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Subject"
                          name="subject"
                          value={values.subject}
                          onChange={handleChange}
                          isInvalid={errors?.subject && touched.subject}
                        />
                      </Form.Group>
                    </Row>

                    <Row className="mb-3">
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="validationFormik102"
                        className="position-relative"
                      >
                        <Form.Label>Text message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={7}
                          type="text"
                          placeholder="Text message"
                          name="text_message"
                          value={values.text_message}
                          onChange={handleChange}
                          isInvalid={
                            errors?.text_message && touched.text_message
                          }
                        />
                      </Form.Group>
                    </Row>
                    <div className="d-flex justify-content-between mt-3 pt-3 w-100  border-top">
                      <Select
                        styles={customStyles}
                        className="multi-select"
                        options={recipientOptions}
                        isMulti
                        onChange={setSelected}
                        value={selected}
                      />
                    </div>
                    <div className="d-flex flex-column  justify-content-end gap-2 mt-4">
                      <div className="d-flex justify-content-end">
                        <button
                          type="submit"
                          className="btn"
                          style={{
                            backgroundColor: "#008000",
                            color: "white",
                          }}
                          onClick={() =>
                            setFieldValue("submitAction", "test_email")
                          }
                        >
                          Send test mail
                        </button>
                      </div>
                      <div className="d-flex justify-content-end pt-2 mt-4 border-top ">
                        <button
                          type="submit"
                          className="btn mt-4"
                          style={{
                            backgroundColor: "#CD1C18",
                            color: "white",
                          }}
                          onClick={() =>
                            setFieldValue("submitAction", "send_email")
                          }
                        >
                          Send mail
                        </button>
                      </div>
                    </div>
                  </Form>
                  <CustomModal
                    size={"md"}
                    title={modalTitle}
                    content={modalContent}
                    footerButtons={modalFooterButtons}
                    show={showConfirmModal}
                    handleClose={handleCloseConfirmModal}
                  />
                  <CustomModal
                    size={"md"}
                    title={"Warning"}
                    content={"Please select email subscription preference!"}
                    footerButtons={[
                      {
                        label: "Close",
                        variant: "danger",
                        onClick: () => {
                          setshowErrorModal(false);
                        },
                      },
                    ]}
                    show={showErrorModal}
                    handleClose={() => {
                      setshowErrorModal(false);
                    }}
                  />
                </section>
              </Col>
              <Col xs={12} md={6}>
                <h4 className="mb-5">Preview:</h4>
                <EmailTempalte
                  custom_greeting={custom_greeting}
                  subject={values?.subject}
                  message={values?.text_message}
                  valediction1={values?.valediction1}
                  valediction2={values?.valediction2}
                />
              </Col>
            </Row>
          )}
        </formik.Formik>
      </Container>
      <div className="footer">
        <h5 className="text-center">
          &copy; {new Date().getFullYear()} boo9 inc.
        </h5>
      </div>
    </div>
  );
};

export default AdminEmail;
